import React, { Component } from "react";
import { Container, Card, CardBody, Row, Col } from "reactstrap";
import { RouterProps } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ComisionesPagadas.form";
import { MemoTable } from "./ComisionesPagadas.table";
import { ComisionesPagadasDispatcher } from "../../../containers/comisiones/comisionesPagadas/ComisionesPagadas.dispatcher";
import { ComisionesPagadasStore } from "../../../containers/comisiones/comisionesPagadas/ComisionesPagadas.store";
import { errorNotification } from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetComisionPagadas } from "../../../reducers/comisiones";
import { formatMoney } from "../../../helpers/formatters";
import { downloadComisionesPagadasCSV } from "../../../actions/comisiones";

interface Props
  extends ComisionesPagadasDispatcher,
    ComisionesPagadasStore,
    RouterProps {}

interface State {
  filters: {
    idEmpleado: number | null;
    fechaPago: string | null;
  };
  downloading: boolean;
}

export default class ComisionComponent extends Component<Props, State> {
  state = {
    filters: {
      idEmpleado: null,
      fechaPago: null
    },
    downloading: false
  };

  componentDidMount(): void {
    this.props.clearComision();
  }

  onDownload = () => {
    const { idEmpleado, fechaPago } = this.state.filters;
    if (!fechaPago) {
      errorNotification("Debe realizar una búsqueda primero");
      return;
    }
    this.setState({ downloading: true });
    downloadComisionesPagadasCSV(idEmpleado, fechaPago, () => {
      this.setState({ downloading: false });
    });
  };

  submit = async (data: { [key in Inputs]: any }) => {
    if (!data.fechaPago) {
      errorNotification("Debe seleccionar una quincena");
      return;
    }

    this.setState({
      filters: {
        idEmpleado: data.idEmpleado || null,
        fechaPago: data.fechaPago
      }
    });

    const preview: Preview<
      GetComisionPagadas
    > = await this.props.getComisionesPagadas(data.idEmpleado, data.fechaPago);

    if (!preview.fulfilled) {
      errorNotification(preview.gettingComisionesPagadasError);
    }
  };

  render() {
    const { comisionesPagadas, gettingComisionesPagadas } = this.props;

    return (
      <Container>
        {comisionesPagadas && (
          <>
            <Row className="mt-4 mb-3">
              <Col md={3}>
                <Card>
                  <CardBody>
                    <h5>Com. de Membresía</h5>
                    <h3>
                      {comisionesPagadas.cantidadComisionesMembresia || 0}
                    </h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card>
                  <CardBody>
                    <h5>Com. de Deportiva</h5>
                    <h3>
                      {comisionesPagadas.cantidadComisionesDeportiva || 0}
                    </h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card>
                  <CardBody>
                    <h5>Otras Comisiones</h5>
                    <h3>{comisionesPagadas.cantidadOtrasComisiones || 0}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card>
                  <CardBody>
                    <h5>Monto Total</h5>
                    <h3>{formatMoney(comisionesPagadas.totalComision || 0)}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
            </Row>
          </>
        )}

        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={gettingComisionesPagadas}
          />
        </div>

        {comisionesPagadas && (
          <MemoTable
            comisiones={comisionesPagadas.comisiones || []}
            loading={gettingComisionesPagadas}
            onDownload={this.onDownload}
            downloading={this.state.downloading}
          />
        )}

        <div style={{ height: "64px" }}></div>
      </Container>
    );
  }
}
